<div class="container-fluid">
  <si-card class="h-100" [heading]="'RESULTS.INFOS.HEADING' | translate">
    <div class="card-body d-flex flex-column" body>
      <table class="overflow-auto table table-hover table-sm mt-3 w-100">
        <thead>
          <th>{{ 'RESULTS.INFOS.VEHICLE_TYPE' | translate }}</th>
          <th>{{ 'RESULTS.INFOS.SIMULATION_ERRORS' | translate }}</th>
          <th>{{ 'RESULTS.INFOS.SIMULATION_WARNINGS' | translate }}</th>
          <th>{{ 'RESULTS.INFOS.SUFFICIENT_ENERGY' | translate }}</th>
          <th>{{ 'RESULTS.INFOS.SCHEDULE_FULFILLED' | translate }}</th>
        </thead>
        <tbody id="drivingTimesResultsTables">
          <tr>
            <td>{{ results().vehicle_type }}</td>
            <td>
              
                @for (error of infoResults().simulation_errors; track $index) {
                  @for (key of getKeys(error); track $index) {
                    {{ key }}:<br />
                    @for (nestedKey of getKeys(error[key]); track $index; let k = $index) {
                      <li>{{ nestedKey }}: {{ error[key][nestedKey] }}</li>
                    }
                  }
                }
              @empty {
                <span class="m-0">{{ 'SHARED.NONE' | translate }}</span>
              }
            </td>
            <td>
              @if (infoResults().warnings.length > 0) {
                {{ infoResults().warnings }}
              } @else {
                <span class="m-0">{{ 'SHARED.NONE' | translate }}</span>
              }
            </td>
            <td>{{ infoResults().sufficient_energy }}</td>
            <td>{{ infoResults().timetable_fulfilled }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </si-card>
</div>
